/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M63.519 448.487l19.85-71.73.8-.8 49.843 49.844-1.127 1.127-69.366 21.559zM342.22 117.869l49.88 49.88-219.515 219.515-49.88-49.88L342.22 117.87zm73.438-61.44l37.919 37.882c3.272 3.308 3.272 8.689 0 11.997l-22.94 22.904-49.88-49.88 22.83-22.867c4.872-4.872 8.29-3.781 12.07-.037zm76.456-.655l-37.883-37.883c-23.776-23.849-65.295-23.849-89.144-.036L39.742 343.274a27.461 27.461 0 00-7.016 12.034L2.006 466.41a27.144 27.144 0 006.47 26.03l10.47 11.053A27.252 27.252 0 0038.725 512c2.727 0 5.454-.4 8.108-1.236l108.666-33.738a27.303 27.303 0 0011.198-6.762l281.72-281.72c.58-.472 1.272-.654 1.817-1.2.509-.545.69-1.235 1.2-1.817l40.682-40.682c24.576-24.576 24.576-64.531 0-89.071z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconSign = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconSign.defaultProps = {
  theme,
};
IconSign.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconSign.displayName = 'IconSign';
export { IconSign };
